import { usePageCapabilities } from '../../Shared/usePageCapabilities';
import { useGroupState } from './GroupContext';

export function useGroupSettingsCapabilities() {
  const state = useGroupState();

  const capabilities = {
    canManageAdmins: !!state?.group?.authenticatedUserIsOwner,
    canDeleteGroup: !!state?.group?.authenticatedUserIsOwner,
    canManageInvitations: !!state?.group?.canManageInvitations,
    canManageJobProspects: !!state?.group?.canManageJobProspects,
  };

  usePageCapabilities(capabilities, []);
}
